// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__Jftaa","slide":"Slider_slide__MOXyA"};